<template>
  <div>
    <!--//@*/*
    //    *RPD  App v1.0
    //    * Copyright (c) 2025, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity.
    //    */
    //-->
    <v-app-bar
      fixed
      app
      max-width="100%"
      class="mx-auto white darken-5"
      absolute
      dense
      style="background-color: #78806f !important; color: white !important"
    >
      <v-app-bar-nav-icon
        v-show="false"
        x-large
        @click="drawer = true"
      ></v-app-bar-nav-icon>
      <v-spacer></v-spacer>

      <!-- <v-img
        max-width="166"
        height="80%"
        width="auto"
        src="../images/badgesex150_40_3_white.png"
      ></v-img> -->
      <v-spacer></v-spacer>
      <div id="div_logoff">
        <v-btn icon text v-show="true" @click="toggle_logoff">
          <v-icon x-large>$person</v-icon>
        </v-btn>
      </div>
    </v-app-bar>
    <div
      class="text-white"
      @click="logoff"
      style="
        z-index: 500;
        background-color: aliceblue;
        text-decoration: underline;
        cursor: pointer;
        position: absolute;
        top: 40px;
        right: 50px;
        padding: 10px;
        border-radius: 4px;
      "
      v-if="showLogoff"
    >
      Logoff: {{ user_email }}
    </div>
    <!-- <div
      id="apptitle"
      style="max-width: 100% margin: auto; margin-top: 60px; background-color: #78806f !important; color: white !important"
      class="text-h5 elevation-2 text-center white font-weight-medium"
    >
      {{ app_title }}
    </div> -->
    <div
      class="d-flex"
      style="
        margin-top: 60px;
        width: 100%;
        background-color: #78806f !important;
        color: white !important;
      "
    >
      <v-spacer></v-spacer>
      <div
        style="background-color: #78806f !important; color: white !important"
        class="text-h5 elevation-2 text-center white font-weight-medium"
      >
        {{ app_title }}
      </div>
      <v-spacer></v-spacer>
    </div>

    <v-navigation-drawer
      id="v-navigation-drawer"
      height="100"
      v-model="drawer"
      absolute
      temporary
    >
      <v-list nav dense close-on-click close-on-content-click>
        <v-list-item-group v-model="group" active-class="primary white--text">
          <v-list-item>
            <v-list-item-icon>
              <v-icon>$home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>$logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: "brandbar",
  data: function () {
    return {
      showLogoff: false,
      user_email: "",
      app_title: "NIBRS Test Admin",
      drawer: false,
      group: null,
    };
  },
  watch: {
    "$store.state.user": function () {
      //keep this
      if (this.$store.state.user != "") {
        this.user_email = this.$store.state.user.email;
      }
    },
  },
  methods: {
    toggle_logoff() {
      this.showLogoff = !this.showLogoff;
    },
    logoff() {
      window.location.replace(
        "https://rpdlogin.org/rpdauth1/?returnURL=https://newsAdmin.renopd.com/"
      );
    },
  },
};
</script>

<style scoped>
i.v-icon.v-icon {
  color: red;
}

.v-icon {
  color: #ffffff !important;
}
</style>
